import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation CreateAppScenario(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $input: ScenarioInput!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          createScenario(input: $input)
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.always(undefined)

export const executor = graphql.createExecutor<
  graphql.schema.CreateAppScenarioMutation,
  undefined,
  graphql.schema.CreateAppScenarioMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
